module.exports = __webpack_public_path__ + "img/gw.4a7ce00d.png";